import { Box, Stack } from '@mui/material';

import {
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonCode,
  MenuButtonCodeBlock,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuButtonRedo,
  MenuButtonStrikethrough,
  MenuButtonTaskList,
  MenuButtonUnderline,
  MenuButtonUndo,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
} from 'mui-tiptap';

interface EditorMenuControlsProps {
  showUndoRedo?: boolean;
  showHeading?: boolean;
  showTextFormatting?: boolean;
  showCodeFormatting?: boolean;
  showListFormatting?: boolean;
}

export default function EditorMenuControls({
  showUndoRedo = true,
  showHeading = true,
  showTextFormatting = true,
  showCodeFormatting = true,
  showListFormatting = true,
}: EditorMenuControlsProps) {
  return (
    <MenuControlsContainer>
      <Box sx={{
 py: 0.5,
px: 1,
maxWidth: '100%',
overflowX: 'auto' 
}}>
        <Stack 
          direction="row" 
          spacing={0.5} 
          sx={{ 
            flexWrap: 'wrap',
            gap: 0.5,
            '& > *': {
              flexShrink: 0
            }
          }}
        >
          {showUndoRedo && (
            <>
              <MenuButtonUndo />
              <MenuButtonRedo />
              <MenuDivider />
            </>
          )}
          {showHeading && (
            <>
              <MenuSelectHeading />
              <MenuDivider />
            </>
          )}
          {showTextFormatting && (
            <>
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuButtonUnderline />
              <MenuButtonStrikethrough />
            </>
          )}
          {showCodeFormatting && (
            <>
              <MenuButtonCode />
              <MenuButtonCodeBlock />
              <MenuDivider />
            </>
          )}
          {showListFormatting && (
            <>
              <MenuButtonBulletedList />
              <MenuButtonOrderedList />
              <MenuButtonTaskList />
            </>
          )}
        </Stack>
      </Box>
    </MenuControlsContainer>
  );
} 